import * as React from 'react';
import { css, SerializedStyles } from '@emotion/core';
import LocalDiv from './LocalDiv';
import { FLEX_ROW } from '../layout/flexBox';
import { COLORS } from '../globalStyle/colors';
import { btnStyle } from '../forms/styles/button';
import Msg from './Msg';
import { Str } from './translationKeys';
import Spacer from '../layout/Spacer';


const styles = {
  root:   css`
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border-radius: 10px; 
    font-size: 12px;
    color: ${COLORS.WHITE}; 
    background-color: ${COLORS.GREEN}; 
  `,
  button: css`
    font-size: 12px;
    min-width: 152px;
  `,
};

type Props = {
  msg: Str | string | number | undefined;

  showBtn?: boolean;
  btnStyle?: SerializedStyles;
  btnMsg?: Str;
  onClick?: () => void;

  className?: string;
};


/**
 * ActionMsg: a component that shows an RTL/LTR-friendly message in a box with an optional button.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ActionMsg: React.FC<Props> = props => (
  <LocalDiv css={[FLEX_ROW, styles.root]} className={props.className}>
    <Msg str={props.msg ?? ''} defaultMsg={props.msg} />
    {
      props.showBtn && <Spacer />
    }
    {
      props.showBtn && (
        <button
          onClick={props.onClick}
          css={[btnStyle.primary(COLORS.WHITE), styles.button, props.btnStyle]}
        >
          <Msg str={props.btnMsg ?? ''} />
        </button>
      )
    }
  </LocalDiv>
);

export default ActionMsg;
